import(/* webpackMode: "eager" */ "/tmp/px-build-1753261077/src/app/layout.js")